import React, { useEffect, useState } from "react";
import './style.css';
import { Layout, Spin, Table,Select, Button,DatePicker, Space, Input, Row, Modal, Col, Dropdown, Menu, Popconfirm } from 'antd';
import {
  PlusOutlined, SearchOutlined, SyncOutlined, MoreOutlined, DeleteOutlined
} from '@ant-design/icons';
import { Link, useHistory, Redirect, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { getAllProcess, addKiv, DDsAndAdsAllProcessSelector, clearState, SearchAllProcess, DeleteProcessAsyn } from './DDsAndAdsAllProcessSlice';
import ability from '../../../config/ability';
import Container from '../../Layout/Container';
import {logout, authSelector} from '../../Auth/authSlice';
import moment from 'moment';
const { Header, Content, Footer } = Layout;
const { Option } = Select;
const { Search } = Input;
const ntop = "none";
const nbottom = "bottomCenter";
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const { confirm } = Modal;


export default function AllProcess() {
  const location = useLocation();
  const { user } = useSelector(
    authSelector
  );
  const loggedInUser = user.username ;

  const dispatch = useDispatch();
  let history = useHistory()
  const [isLoading, setLoading] = React.useState(false);
  const { isFetching, isAllProcessSuccess, isError, errorMessage, AllProcessData, processCount } = useSelector(
    DDsAndAdsAllProcessSelector
  );

  const [AllProcessInfo, setDataSource] = useState([]);
  let [storepage, setstorePage] = useState(1);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [pheader, setPheader] = useState("All Process");
  const [pagecount,setPagecount] = useState()
  let myStopePage=0;

  // In the fifth row, other columns are merged into first column
  // by setting it's colSpan to be 0
  const renderContent = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    // if (index === 4) {
    //   obj.props.colSpan = 0;
    // }
    return obj;
  };

  const columns = [
    {
      title: 'Ref. No.',
      dataIndex: 'refno',
      render: renderContent,
    },
    {
      title: 'Process Subject',
      dataIndex: 'subject',
      render: renderContent,
    },
    {
      title: 'Created On',
      dataIndex: 'created_on',
      render: renderContent,
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      render: renderContent,
    },

    {
      title: 'KIV',
      dataIndex: 'kiv',
      render: (text, row, index) => {
        return {
          children: <a onClick={(e) => showConfirm(row,
            e,)}><button>KIV</button></a>
        };
      },
    },

    

    {
      title: 'ACTION',
      dataIndex: 'action',
      render: (text, row, index) => {
        return {
          children: <a onClick={(e) => handleProcessClick(row,
            e,
            storepage,
            search, 
           selectedOption,
           pheader,
           pagecount,
             )}>View Log</a>
        };
      },
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      fixed: "left",
      width: 100,
      render: (text, row, index) => {
        return {
          children: <>{row.checkDel.length > 0 &&
            <Dropdown
              overlay={() => menu(row)}
              trigger={["click"]}
              placement="bottomRight"
              arrow
            >
              <a
                style={{ color: "#c5c7cd", fontSize: 25 }}
                onClick={(e) => e.preventDefault()}
              >
                <MoreOutlined />
              </a>
            </Dropdown>
          }</>,
        };
      },

    },
  ];



  const menu = (row) => (
    <Menu>
      <Menu.Item key="1">
        <Popconfirm
          title="Are you sure you want to delete this process?"
          onConfirm={(e) => DelCompletedconfirm(e, row)}
          // onCancel={cancel}
          okText="Yes"
          cancelText="No"
          icon={<DeleteOutlined style={{ color: 'red' }} />}
        >
          <DeleteOutlined /> &nbsp; Delete
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );

  const DelCompletedconfirm = (e, row) => {
    e.preventDefault();
    // console.log(e.key + " row = " + row.action);
    dispatch(DeleteProcessAsyn(row.action));
    setTimeout(() => {
      dispatch(getAllProcess(page));
    }, 100);

  }




  const data = [
    {
      key: '1',
      name: 'Recruitment request',
      action: 'View Log',
      created_on: '1 Jul 2021',
      created_by: 'John Doe',
    },
    {
      key: '2',
      name: 'Recruitment request',
      action: 'View Log',
      created_on: '1 Jul 2021',
      created_by: 'John Doe',
    }
  ];


   //myuseeffect
   useEffect(() => {

    const ChangePagination = (v,y) => {
    
      //setPage(v);
     setTimeout(()=>{
  
      if (v) {
        let q = 'search=' + y + '&page=' + v + '&limit=10';
        dispatch(SearchAllProcess(q)).then(res => {
          if (res) {
            let udata = res.data;
            console.log(udata,'udata')
            setDataSource(udata.data);
          
            setPage(v);
            
          }
        });
      }
      else {
        setPage(v);
        dispatch(getAllProcess(v));
      }
  
     },200)
     
     
     }
  
    if (location.state !== undefined) {
   //  setSelectedOption(location.state.option)
     setPage(location.state.dynamicPage);
     setstorePage(location.state.dynamicPage);
     setSelectedOption(location.state.option)
     setPheader(location.state.header)
     setPagecount(location.state.count)
    
     setSearch(location.state.backsearch)
  
      ChangePagination(location.state.dynamicPage,location.state.backsearch);
     
      // ChangeAllProcessPagination ();
     console.log(page,'newnewPage')
   //  console.log(location.state.backsearch,'back')
      // setSearch(location.state.backsearch)
     // console.log(location.state.backsearch,'newsearch')
  
  
    } 
  
  
  }, [location]);
  

  useEffect(() => {
    setLoading(true);
    dispatch(clearState());
    dispatch(getAllProcess(page));
  }, []);

  useEffect(() => {

    if (isError) {
      setLoading(false);

      // toast.error(errorMessage);
    }
    if (isAllProcessSuccess) {
      setLoading(false);
      setDataSource(AllProcessData.data);
      setPagecount(processCount)
    }
  }, [isError, isAllProcessSuccess, setLoading, AllProcessData, setDataSource]);

  const showConfirm = (row,e) => {
    confirm({
      title: 'Store in KIV ?',
      // icon: <ExclamationCircleFilled />,
      // content: 'Clicking OK would automatically log document and all changes in real-time.',
      onOk() {
    
console.log(row,"myrow")
const storeKiv = {
  "processId": row.action,
 "username":loggedInUser,
 "subject": row.subject,
  "date": row.created_at,
  "createdBy": row.created_by,
  "refno": row.refno,
}
dispatch(addKiv(storeKiv));
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  const handleProcessClick = (row, e,storepage,y,u,v,w) => {
    setstorePage(page) ;
     if(location.state !=undefined){
       setstorePage(location.state.dynamicPage) 
     }
     //  console.log("click", row, "e", e);   
     history.push({
       pathname: '/view-process',
       state: { 
        processName: row.action , 
        mystorepage: storepage, 
        mysearch:y, 
        myOption:u,
        myheader:v,
        mycount:w
      }
     });
 
   }




   const ChangeAllProcessPagination = (v) => {
    

    
    setstorePage(v.current)
   setPage(v.current)
    console.log(page ,"cp:")
  // if (v) {
     let q = 'search=' + search + '&page=' + v.current + '&limit=10';
     dispatch(SearchAllProcess(q)).then(res => {
       if (res) {
         let udata = res.data;
         //console.log(udata,'udata');

         setDataSource(udata.data)
       }
     });


 }


  
 
   
  
    const searchProcess = () =>{
      let filteredData =  AllProcessData.data.filter(function(item) {
        return item.subject.includes(search);
    });
   setDataSource(filteredData)
   // console.log(filteredData,'ccc')
   // setPage(1);
    }

  let dataSource = isLoading
    ? []
    : AllProcessInfo && AllProcessInfo ? AllProcessInfo.map(row => ({
      id: row._id,
      refno: row.newrefno,
      subject: row.newsubject,
      action: row.processId,
      created_on: moment(row.created_at).format("ll"),
      created_by: row.username.toUpperCase(),
      checkDel:'',
      // checkDel: row.delete,
    })) : [];


    let onDateChange = (value, dateString) => {
      setPheader('All Process');
      // console.log('Selected Time: ', moment(value).format());
      //  let data = `isStatus=${currentTab}&date=2021-09-16T07:27:14.194+00:00`;
      //    2021-09-21T00: 00: 00 + 05: 30
      if (dateString) {
          // console.log('Formatted Selected Time: ', moment(dateString).format('YYYY-MM-DD'));
       
    
    let mydate = `${moment(dateString).format('YYYY-MM-DD')}`;
    //let test = '2022-10-31T21:31:25.029Z';
    console.log(mydate);
    
    let q = 'search=' + mydate + '&page=' + page + '&limit=10';
    // let q = 'search=' + currValue ;
     dispatch(SearchAllProcess(q)).then(res => {
       if (res) {
         let udata = res.data;
        
         setDataSource(udata.data);
         setPagecount(udata.count);
        setPage(1);
       }else {
        setDataSource([]);
        setPagecount(0);
       }
     });
    
        //   let filteredData =  AllProcessData.data.filter(function(item) {
        //     return item.created_at.includes(mydate);
           
        // });
    
      //  setDataSource(filteredData)
      //   console.log(filteredData,'ndate')
       // setPage(1);
    
    
      }
      else {
        dispatch(getAllProcess(page)).then(res => {
          if (res) {
            let udata = res.data;
            setDataSource(udata);
            setSelectedOption('Inbox & Sent')
            setPage(1);
          }
        });
        setSelectedOption('Inbox & Sent')
      
          // let data = `isStatus=${currentTab}&page=${page}&limit=10&&date=${moment().format('YYYY-MM-DD')}`;
          // dispatch(getStatusTable(data));
      }
    
    }
    
    
    
    
    //  },1000)
    
    // if(location.state !=undefined){
    //   console.log(location.state.dynamicPage,'dpage');
    //   // dispatch(getAllProcess(location.state.dynamicPage));
    //  setPage(location.state.dynamicPage);
     
      
    //  }
    
    const [selectedOption, setSelectedOption] = useState("Inbox & Sent");
    const fetchSearch = (x)=>{
      setPheader('All Process');
      let q = 'search=' + x + '&page=' + 1 + '&limit=10';
      // let q = 'search=' + currValue ;
       dispatch(SearchAllProcess(q)).then(res => {
         if (res) {
           let udata = res.data;
          
           setDataSource(udata.data);
           setPagecount(udata.count);
         setPage(1);
    
         }else {
           setDataSource([]);
           setPagecount(0);
         }
       });
    
    
    }
    const fetchFolderInbox = ()=>{
      setPage(1);
    
    
      let q = 'search=' + `00000inbox${loggedInUser}` + '&page=' + 1 + '&limit=10';
      // let q = 'search=' + currValue ;
       dispatch(SearchAllProcess(q)).then(res => {
         if (res) {
           let udata = res.data;
        
           setDataSource(udata.data);
         
           setPagecount(udata.count);
         setPage(1);
         }else {
           setDataSource([]);
           setPagecount(0)
         }
       });
     
     
    }
    
    const fetchFolderSent = ()=>{
      setPage(1);
      let q = 'search=' + `00000!nbox${loggedInUser}` + '&page=' + 1 + '&limit=10';
    
      dispatch(SearchAllProcess(q)).then(res => {
        if (res) {
          let udata = res.data;
       
          setDataSource(udata.data);
        
          setPagecount(udata.count);
        setPage(1);
        }else {
          setDataSource([]);
          setPagecount(0)
        }
      });
     
      //setHcount(filteredData.length);
      
      // setPage(1);
    
    
    }
    
    const fetchAllFolder = ()=>{
      setPage(1);
      dispatch(getAllProcess(page)).then(res => {
        if (res) {
          let udata = res.data;
          setDataSource(udata);
          setPagecount(processCount)
          setPheader('All Process');
          setPage(1);
        }
      });
    
    }
    
    
 

    const myhandleChange = (value) => {
 
      setSelectedOption(value);
     value=='inbox'? setPheader('Inbox') 
     : value=='sent'? setPheader('Sent')
    :setPheader('All Process');
    
    value=='inbox'? fetchFolderInbox()
    : value=='sent'? fetchFolderSent()
    :fetchAllFolder();
    
    
    value === 'sent' ? setSearch(`00000!nbox${loggedInUser}`) 
    : value === 'inbox' ? setSearch(`00000inbox${loggedInUser}`)
    : setSearch('');
    
    console.log(search,"checking search")
    }
     


  return (
    <>
      <Container>

        <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
        {/* <div className="site-layout-content" style={{marginTop:35,marginBottom:35,border:"1px solid #dfe0eb"}}> */}
        <div className="site-layout-content" style={{ marginTop: 5 }}>
          <div style={{ padding: 24, paddingTop: 16 }}>
            <h2 style={{ paddingLeft: 16, paddingTop: 20, borderTop: '1px solid #dfe0eb', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', marginBottom: 0, backgroundColor: '#ffffff' }}>{pheader} ({pagecount ? pagecount : 0})</h2>
            <Space style={{ padding: 16, width: '100%', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', backgroundColor: '#ffffff' }} size="large">
              <Row style={{ width: '100%' }}>
                <Col span="10">
                <div style={{display:'flex', justify:'space-between'}}> 
                <Input  placeholder="Search process by subject or ref.no." size="large" 

onChange={e => {
  const currValue = e.target.value;
  setSearch(currValue);


  currValue ? fetchSearch(currValue): fetchAllFolder()



}}

/>

<DatePicker onChange={onDateChange} style={{marginLeft:'4px'}}  size="large" format={'ll'} />
 

</div>


                </Col>
                <Col span="14" style={{ textAlign: 'right' }}>

                <Space>
                  <Select
                  style={{ width: 120 }}
                  defaultValue="inbox" value={selectedOption} onChange={myhandleChange}>
           <Option value="Inbox & Sent">Inbox & Sent</Option>
      <Option value="inbox">Inbox</Option>
      <Option value="sent">Sent</Option>
    </Select>
                  </Space>

                  <Space>
                    {/* {ability.can('allProcessTab', 'manage/editTemplates') &&
                      <Link to="/manage-template"><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 14 }} type="primary" ghost>Manage Template</Button></Link>
                    } */}
                    {/* <Link to="/manage-template"><Button size="large" style={{borderRadius:5,padding:'6.4px 8px',fontWeight:600,fontSize:14}}  type="primary" ghost>Manage Template</Button></Link> */}
                    {/* {ability.can('allProcessTab', 'createTemplates') &&
                      <Link to="/new-template"><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 14 }} type="primary" icon={<PlusOutlined />}>New Template</Button></Link>
                    } */}
                  </Space>
                </Col>
              </Row>
            </Space>

            <Table
              columns={columns}
              onChange={ChangeAllProcessPagination}
              
              pagination={{
                current:page,
                position: [ntop, nbottom],
                size: "small",
                defaultPageSize: 10,
                total: pagecount ? pagecount : 0,
                hideOnSinglePage: true,
              }}
              dataSource={dataSource}
              className="clerk-all-process-table"
              bordered
            />


          </div>

        </div>
      </Container>
    </>
  );
}
